import React from 'react'
import { TabItem } from '../../design_system/components/Tabs/TabItem.jsx'

const ALL_TYPES = [
    {label: "News Results", key: "news_results"},
    {label: "Job Updates", key: "job_updates"}
]

const LowConfidenceTypesFilter = ({
    activeType,
    setActiveType,
    ...props
}) => {
    return (
        <div className="flex items-center gap-s">
            {ALL_TYPES.map(lType => (
                <TabItem
                    key={lType.key}
                    label={lType.label}
                    variant="block"
                    isActive={lType.key === activeType}
                    onClick={() => setActiveType(lType.key)}
                />
            ))}
        </div>
    )
}

export default LowConfidenceTypesFilter
